import React from 'react';
import { Col, Form, Input, Row } from 'antd';

const StartCooridinates = () => {
    return (
        <Row gutter={[10, 10]}>
            <Col span={24} md={12}>
                <Form.Item name="startCoordinatesLat" label="Początek trasy">
                    <Input addonAfter="lat (Szerokość)" />
                </Form.Item>
            </Col>
            <Col span={24} md={12}>
                <Form.Item name="startCoordinatesLng">
                    <Input addonAfter="lng (Długość)" />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default StartCooridinates;
